import { render, staticRenderFns } from "./list-treatment.vue?vue&type=template&id=2699de4b"
import script from "./list-treatment.vue?vue&type=script&lang=js"
export * from "./list-treatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports